import classNames from "classnames";
import { useEffect, useState } from "react";
import { OTPMAXTIME } from "../../utils/constants";

export const CountdownTimer = ({
  onClick = () => {},
  text = "Resend",
  onTimerComplete = () => {},
  showInSeconds = true,
  time = OTPMAXTIME,
  timeClassName = "",
  className = "",
}: {
  onClick: () => void;
  text: string;
  onTimerComplete?: () => void;
  showInSeconds?: boolean;
  time?: number;
  timeClassName?: string;
  className?: string;
}) => {
  const [countValue, setCountValue] = useState(time);

  useEffect(() => {
    const myTimeout =
      countValue > 0 &&
      setTimeout(() => {
        setCountValue(countValue - 1);
      }, 1000);

    return () => {
      if (myTimeout) {
        clearTimeout(myTimeout);
      }
    };
  });

  useEffect(() => {
    if (countValue === 0) {
      onTimerComplete();
    }
    // eslint-disable-next-line
  }, [countValue]);

  return (
    <p className={classNames("text-sm text-grey-600", className)}>
      {text}{" "}
      <span
        onClick={() => {
          if (countValue > 0) {
            return;
          }
          onClick();
          setCountValue(time);
        }}
        className={classNames("underline", timeClassName)}
      >
        {showInSeconds && (
          <>
            {countValue > 0
              ? `in ${countValue} ${countValue > 1 ? "secs" : "sec"}`
              : "now"}
          </>
        )}

        {!showInSeconds &&
          `${String(Math.floor(countValue / 60)).padStart(2, "0")}:${String(
            countValue % 60,
          ).padStart(2, "0")}`}
      </span>
    </p>
  );
};
